const fourDigits = /^[0-9]{4}$/;
const fiveDigits = /^[0-9]{5}$/;
const sixDigits = /^[0-9]{6}$/;
const sevenDigits = /^[0-9]{7}$/;
const threeSpaceTwo = /^[0-9]{3}[ ]?[0-9]{2}$/;
const countryCodeToRegex = {
    AD: /.*/,
    AE: /.*/,
    AT: fourDigits,
    AU: fourDigits,
    BE: fourDigits,
    BG: fourDigits,
    CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: fourDigits,
    CL: sevenDigits,
    CN: /^([0-9]{6})?$/,
    CY: fourDigits,
    CZ: threeSpaceTwo,
    DE: fiveDigits,
    DEFAULT: /^[a-zA-Z0-9\-\s]{1,}$/i,
    DK: fourDigits,
    EE: fiveDigits,
    ES: /^([0-4][0-9]|[5][0-2])[0-9]{3}$/,
    EU: /.*/,
    FI: fiveDigits,
    FR: fiveDigits,
    GB: /^[a-zA-Z]{1,2}([0-9]{1,2}|[0-9][a-zA-Z])\s*[0-9][a-zA-Z]{2}$/,
    GI: /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?[0-9][A-Z]{2}$/,
    GR: threeSpaceTwo,
    HK: /.*/,
    HR: fiveDigits,
    HU: fourDigits,
    IE: /^([a-zA-Z0-9\s]{1,9})?$/,
    IL: sevenDigits,
    IN: sixDigits,
    IS: /^[0-9]{3}$/,
    IT: fiveDigits,
    JO: fiveDigits,
    JP: /^[0-9]{3}-[0-9]{4}$/,
    KR: /^([0-9]{3}[-]?[0-9]{3}|[0-9]{5})$/,
    LI: fourDigits,
    LT: fiveDigits,
    LU: fourDigits,
    LV: /^(((LV)[-]?)?[0-9]{4})$/,
    MC: fiveDigits,
    MO: /.*/,
    MT: /^[a-zA-Z]{3} [0-9]{4}$/,
    MX: fiveDigits,
    MY: fiveDigits,
    NL: /^[0-9]{4}[ ]?[A-Za-z]{2}$/,
    NO: fourDigits,
    NZ: fourDigits,
    PH: fourDigits,
    PL: /^[0-9]{2}-[0-9]{3}$/,
    PR: /^00[0-9]{3}$/,
    PT: /^[0-9]{4}-[0-9]{3}$/,
    QA: /^[0-9]{1,2}$/,
    RO: sixDigits,
    RS: /.*/,
    RU: sixDigits,
    SA: fiveDigits,
    SE: threeSpaceTwo,
    SG: sixDigits,
    SI: /^(((SI)[-]?)?[0-9]{4})$/,
    SK: threeSpaceTwo,
    SM: fiveDigits,
    /**
     * To type TH (Thai) characters on macOS, you have to add the "Thai - Pattachote" keyboard then switch to that keyboard.
     *  Depending on which Thai keyboard you select, not only are the numbers translated, the actual numbers are located on different areas of the keyboard
     *  Not all the numbers are in the top number bar like English keyboards.
     **/
    TH: /^[0-9๐-๙]{5}$/,
    TR: /^[0-9]{4,5}$/,
    TW: /^([0-9]{3}[-]?([0-9]{0,3})?)$/,
    US: /^([0-9]{5})(-[0-9]{4})?$/,
};
export default countryCodeToRegex;
